import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, FormGroup, InputGroup, Modal } from 'react-bootstrap';

class CommentBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    toggleModal = () => {
        this.setState(state => ({
            showModal: !state.showModal,
        }));
    };

    render() {
        const { rowIsLast, handleChange, value } = this.props;
        return (
            <div>
                <FormGroup style={{ marginBottom: 0 }}>
                    <InputGroup>
                        <FormControl
                            type="text"
                            disabled={!rowIsLast}
                            value={value}
                            onChange={handleChange}
                        />
                        <InputGroup.Button>
                            <Button disabled={!rowIsLast} onClick={this.toggleModal}>
                                ...
                            </Button>
                        </InputGroup.Button>
                    </InputGroup>
                </FormGroup>
                <Modal show={this.state.showModal}>
                    <Modal.Body>
                        <FormControl
                            componentClass="textarea"
                            value={value}
                            onChange={handleChange}
                            rows="15"
                            maxLength="1000"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.toggleModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

CommentBox.propTypes = {
    rowIsLast: PropTypes.bool,
    value: PropTypes.string,
    rowNumber: PropTypes.number,
    handleChange: PropTypes.func,
};
CommentBox.defaultProps = {};

export default CommentBox;
